import { gql, TypedDocumentNode } from '@common/hooks';
import {
  RegenerateScheduleRunMutationCgResponse,
  RegenerateScheduleRunMutationVariables,
} from '@common/graphql';

// Post-Team-Review trigger behind "Confirm & Generate Schedules": rejects the period's
// in-review run (if any) and starts a fresh greedy run for the (service line, period).
// Returns immediately with a `pending` run — the heavy generation runs async in Sidekiq.
export const REGENERATE_SCHEDULE_RUN_MUTATION: TypedDocumentNode<
  RegenerateScheduleRunMutationCgResponse,
  RegenerateScheduleRunMutationVariables
> = gql`
  mutation RegenerateScheduleRun(
    $serviceLineId: ID!
    $schedulingPeriodId: ID!
  ) {
    regenerateScheduleRun(
      serviceLineId: $serviceLineId
      schedulingPeriodId: $schedulingPeriodId
    ) {
      balancerRunId
      state
    }
  }
`;
